/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useRef } from 'react'
import ApexCharts, { ApexOptions } from 'apexcharts'
import { getCSS } from '../../../assets/ts/_utils'
import { useThemeMode } from '../../layout/theme-mode/ThemeModeProvider'

type Props = {
  className: string
  data?: any
  label?: string
}

const ChartsWidget9C1: React.FC<Props> = ({ className, label, data }) => {
  const chartRef = useRef<HTMLDivElement | null>(null)
  const { mode } = useThemeMode()

  const refreshChart = () => {
    if (!chartRef.current || !data) {
      return
    }

    const height = parseInt(getCSS(chartRef.current, 'height'))

    // Simple extraction of data
    const series = data.map((item: any) => {
      // Try to find a numerical value
      if (item.quantity !== undefined) return item.quantity
      if (item.quantitySupplied !== undefined) return item.quantitySupplied
      if (item['Post Industrial'] !== undefined) return item['Post Industrial']
      if (item['Post Consumer'] !== undefined) return item['Post Consumer']
      if (item.value !== undefined) return item.value

      // Fallback
      return 0
    })

    const labels = data.map((item: any) => {
      return item.name || item.pickupPointName || ''
    })

    const options = {
      series: series,
      chart: {
        type: 'pie',
        height: height,
      },
      legend: {
        position: 'bottom',
        show: true,
      },
      dataLabels: {
        enabled: true,
        formatter: function (val: any) {
          return parseFloat(val).toFixed(1) + '%'
        },
      },
      labels: labels,
    }

    const chart = new ApexCharts(chartRef.current, options)
    if (chart) {
      chart.render()
    }
    return chart
  }

  useEffect(() => {
    const chart = refreshChart()
    return () => {
      if (chart) {
        chart.destroy()
      }
    }
  }, [chartRef, mode, data])

  return (
    <div className={`card ${className}`}>
      <div className='p-2 text-center fw-bold fs-4'>{label}</div>
      <div className='card-body'>
        <div ref={chartRef} id='kt_charts_widget_5_chart' style={{ height: '250px' }}></div>
      </div>
    </div>
  )
}

export { ChartsWidget9C1 }